export default "__VITE_ASSET__VJWl63oE__"